import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import { IImage } from '@models/IImage';
import { ILink } from '@models/ILink';
import { IVideo } from '@models/IVideo';
import InViewVideo from '@molecules/InViewVideo/InViewVideo';
import updateDataLayer from '@utils/helpers/gtm';

interface Props {
  readonly title?: string;
  readonly text?: string;
  readonly primaryCTA?: ILink;
  readonly dataTestId?: string;
  readonly media: IVideo | IImage;
}

const TabbedFeatureSlide = ({
  title,
  text,
  primaryCTA,
  dataTestId,
  media,
}: Props) => (
  <div className="flex w-full grid-cols-12 flex-col gap-5 xl:grid xl:gap-0">
    {'url' in media && media.url ? (
      <div className="flex aspect-3/2 xl:col-span-6">
        <InViewVideo
          video={media as IVideo}
          dataTestId={`${dataTestId}-Video`}
          videoClasses="[&>div>video]:object-cover h-full pointer-events-none"
          wrapperClasses="w-full"
          autoPlay
          hasInVideoPlayButton
          controls={false}
        />
      </div>
    ) : (
      <div className="flex aspect-3/2 xl:col-span-6">
        <Image
          image={media as IImage}
          imageClasses="w-full aspect-3/2 object-cover object-center"
          classes="w-full"
          dataTestId={`${dataTestId}-Image`}
        />
      </div>
    )}

    <div className="xl:col-span-4 xl:col-start-8 xl:self-center">
      {title && (
        <p className="h3 mb-5 xl:mb-7.5" data-testid={`${dataTestId}-Title`}>
          {title}
        </p>
      )}
      {text && (
        <div
          className="body-two text-grey-500 content-area"
          dangerouslySetInnerHTML={{ __html: text }}
          data-testid={`${dataTestId}-Text`}
        />
      )}
      {primaryCTA?.url && primaryCTA?.name && (
        <Button
          className="mt-7.5 xl:mt-10"
          link={primaryCTA}
          linkCallback={() => {
            updateDataLayer({
              event: 'selectContent',
              content_type: 'tabbed_feature_carousel_content',
              link_text: primaryCTA.name,
            });
          }}
          dataTestId={`${dataTestId}-CTA`}
        />
      )}
    </div>
  </div>
);

export default TabbedFeatureSlide;
